import { combineReducers } from 'redux';
import { AdminUserPagination } from './AdminUserPagination.reducer';
import { alert } from './alert.reducer';
import authentication from './authentication.reducer';
import { DAPList } from './dap.reducer';
import { DistributorList } from './DistributorList.reducer';
import { offerList } from './OfferList.reducer';
import { SkuList } from './SkuList.reducer';
import { UsersList } from './userslist.reducer';
import { Products } from './Products.reducer';
import { FilterData } from './ProductFilters.reducer';

const rootReducer = combineReducers({
    alert, authentication, UsersList, AdminUserPagination, DistributorList, offerList, SkuList, DAPList, Products, FilterData,
});
export default rootReducer;
